export enum ID {
  LANDING_PAGE_MAIN = 'landing-page-main',
  LANDING_PAGE_SUCCESS_BOX = 'landing-page-success-box',
  APP_HEADER = 'header-content',
  APP_WRAPPER = 'app-wrapper',
  DIALOG_CONTENT = 'dialog-content',
  QUIZ_HEADER = 'quiz-head',
  QUIZ = 'quiz',
}
